import EfSpec from '@elem/ui/ef-spec';
import EfLink from '@elem/ui/ef-link';
import { useEffect, useMemo, useState } from 'react';
import EfImg from '@elem/ui/ef-img';
import { LearnMoreList } from '../../common';
import css from './index.module.scss';
import { A_DATA } from './common';
import getLocal from '@/app/utils/getLocal';
import { getIsLogin } from '@/utils/cookie';
import { signupCookie } from '@/utils/cookies/signupCookie';

export default function A() {
    const { locale } = getLocal();
    const { moduleTitle, list } = A_DATA[locale] || A_DATA.us;
    const [isLogin, setIsLogin] = useState(false);
    const links = ['eu', 'de', 'fr', 'it', 'es', 'uk'];
    const benefitsSiteList = ['us', 'ca', 'za', 'au', 'eu', 'uk', 'ph', 'cn', 'jp'];
    if (typeof window == 'undefined') {
        return <></>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const NAV_LIST = [
        {
            // 热门服务
            title: list[0].title,
            desc: list[0].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732526996595/Support-A-1.png',
            link: isLogin ? 'support/get-support' : `/${locale}/login?redirect=${encodeURIComponent(window.location.href)}/get-support`,
        },
        {
            // 服务进度
            title: list[1].title,
            desc: list[1].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732526996754/Support-A-2.png',
            link: isLogin ? 'support/service-status' : `/${locale}/login?redirect=${encodeURIComponent(window.location.href)}/service-status`,
        },
        {
            // 售后政策
            title: list[3].title,
            desc: list[3].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732526997165/Support-A-3.png',
            link: ['eu', 'de', 'fr', 'it', 'es', 'uk', 'br', 'mx'].includes(locale)
                ? `https://${locale}.ecoflow.com/pages/policy`
                : locale === 'jp'
                ? `https://${locale}.ecoflow.com/pages/warranty-policy`
                : 'support/policy',
        },
        {
            // 保修登记
            title: list[2].title,
            desc: list[2].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732526997187/Support-A-4.png',
            link: 'support/warranty',
        },
        {
            // 订单追踪
            title: list[4].title,
            desc: list[4].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732527170772/Support-A-5.png',
            link: `https://${locale}.ecoflow.com/a/track-order?page_path_refererer=%2Fde&brand_referer=EcoFlow+DE&timestamp=1732672116127`,
        },
        {
            // FAQ
            title: list[5].title,
            desc: list[5].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732527249313/Support-A-6.png',
            link: 'support/faq',
        },
        {
            // 文档与手册
            title: list[6].title,
            desc: list[6].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732527253383/Support-A-7.png',
            link: 'support/download/index',
        },
        {
            // 联系我们
            title: list[7].title,
            desc: list[7].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732527256575/Support-A-8.png',
            link: 'contact-us',
        },
        {
            // app
            title: list[8].title,
            desc: list[8].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1732527256752/Support-A-9.png',
            link: locale === 'tw' ? 'support/download/index' : 'app',
        },
        {
            // 权益查询
            title: list[9].title,
            desc: list[9].desc,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1761126140747/Key%20Line.png',
            link: isLogin ? 'support/benefits-inquiry' : `/${locale}/login?redirect=${encodeURIComponent(window.location.href)}/benefits-inquiry`,
        },
    ];

    const List = useMemo(() => {
        switch (locale) {
            case 'us':
            case 'ca':
            case 'uk':
            case 'eu':
            case 'au':
            case 'za':
                return [NAV_LIST[0], NAV_LIST[1], NAV_LIST[3], NAV_LIST[2]];
            case 'de':
            case 'fr':
            case 'it':
            case 'es':
            case 'jp':
            case 'kr':
                return [NAV_LIST[3], NAV_LIST[2], NAV_LIST[4], NAV_LIST[5]];
            case 'sa':
            case 'cn':
            case 'br':
            case 'nl':
            case 'mx':
                return [NAV_LIST[2], NAV_LIST[5], NAV_LIST[6], NAV_LIST[7]];
            case 'tw':
                return [NAV_LIST[5], NAV_LIST[6], NAV_LIST[7], NAV_LIST[8]];
            default:
                return [NAV_LIST[0], NAV_LIST[1], NAV_LIST[3], NAV_LIST[2]];
        }
    }, [NAV_LIST, locale]);

    if (benefitsSiteList.includes(locale)) {
        List.push(NAV_LIST[9]);
    }
    useEffect(() => {
        setIsLogin(getIsLogin());
    }, []);
    return (
        <div className={`support-module ${css['Support']}`}>
            <EfSpec />
            <div className="support-title">{moduleTitle}</div>

            <div className={`A-list ${benefitsSiteList.includes(locale) ? 'len-5' : 'len-4'}`}>
                {List.map((i, idx) => (
                    <div className="A-list-item" key={idx}>
                        <div className="A-list-item-icon">
                            <EfImg pc={i.icon} />
                        </div>
                        <span className="A-list-item-title">{i.title}</span>
                        <span className="A-list-item-desc">{i.desc}</span>
                        <EfLink
                            className="A-list-item-link support-link"
                            href={i.link}
                            dataLayer={[
                                {
                                    event: 'uaEvent',
                                    event_name: 'support_navigation',
                                    navigation_name: i.title,
                                },
                            ]}
                            onClick={() => {
                                // 判断 link 里面存在 login
                                if (i?.link?.includes?.('/login?')) {
                                    signupCookie({ sector_name: `${moduleTitle}_${i.title}`, entry_position: 2 });
                                }
                            }}
                        >{`${LearnMoreList[locale]} >`}</EfLink>
                    </div>
                ))}
            </div>
        </div>
    );
}
